import styled from 'styled-components';

export const Container = styled.div`
  display: ${props => (props.actived ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 129px;
  width: 100%;
  background: ${props => props.primaryColor || '#e4e7ec'};
  background-blend-mode: soft-light;
  filter: alpha(Opacity=90);
    @media only screen and (max-width: 950px) {
    padding: 20px;
  }
`;

export const Title = styled.span`
  /* font-family: "Source Sans Pro"; */
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  color: ${props => props.primaryColor || '#667085'};

  @media only screen and (max-width: 950px) {
    /* font-family: "Source Sans Pro"; */
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: ${props => props.primaryColor || '#667085'};
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin-top: 28px;
  flex-wrap: wrap;

  a {
    svg {
      width: 20px;
    }
  }
`;
